interface Props { url: string }

export function LinkPreview({ url }: Props) {
  let domain = ''
  try {
    domain = new URL(url).hostname
  } catch {
    return null
  }

  const favicon = `https://www.google.com/s2/favicons?domain=${domain}&sz=32`

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2.5 mt-2 p-2.5 bg-black/10 rounded-xl hover:bg-black/20 transition-colors no-underline"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={favicon}
        alt={domain}
        width={20}
        height={20}
        className="rounded-sm shrink-0"
        onError={(e) => { e.currentTarget.style.display = 'none' }}
      />
      <div className="min-w-0 flex-1">
        <p className="text-txt-link text-xs font-medium truncate">{domain}</p>
        <p className="text-txt-meta text-[11px] truncate">
          {url.length > 60 ? url.slice(0, 60) + '…' : url}
        </p>
      </div>
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-txt-meta shrink-0"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    </a>
  )
}
